import { CheckoutCardOptions } from '../../types';

export const isCardholderNameVisible = (options: CheckoutCardOptions = {}) => {
  return (
    options?.cardholderName?.visible === undefined || // default to true
    options?.cardholderName.visible === true
  );
};

export const isCardholderNameRequired = (options: CheckoutCardOptions = {}) => {
  const visible = isCardholderNameVisible(options);

  if (!options.cardholderName) {
    // @deprecated v1.2.0

    if (
      options.cardholderNameRequired === undefined ||
      options.cardholderNameRequired === true
    ) {
      return visible;
    }

    return false;
  }

  if (options.cardholderName)
    if (
      options.cardholderName?.required === undefined ||
      options.cardholderName?.required === true
    ) {
      return visible;
    }

  if (options.cardholderName?.required === false) {
    return false;
  }

  return false;
};
